// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

export default createVuetify({
  theme: {
    defaultTheme: 'floowDark',
    themes: {
      floowDark: {
        dark: true,
        colors: {
          background: '#14141a',
          surface: '#1a1a1a',
          primary: '#ffffff',
        },
      },
    },
  },
})
